import { IconProps } from '@/root/shared-types/ui/ui-types'
import React, { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const AgreeIcon: FC<IconProps> = ({ width = 19, height = 14, ...rest }) => (
  <Icon type="Agree" width={width} height={height} alt="Agree" {...rest} />
)
